import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import swal from 'sweetalert'
import {
	appAllGetTeams,
	appAllGetPermission,
	appCreateTeams,
	appUpdateTeams,
	appDeleteTeams,
} from '../../store/teams/index'
import { appGetAllUser } from '../../store/user'
import PostPreview from '../PostPreview/PostPreview'
import { teamExportColumns } from '../../config/exportColumns/teamExportColumns'
import ExportButton from '../../common/ExportButton'
import { designationOptions } from '../../common/jsonData'

function Management({ hubDetails, sansthaDetails, teamsList }) {
	//	console.log('teamsList', teamsList.permissions)
	const params = useParams()
	const dispatch = useDispatch()
	const [page, setPage] = useState(params.page || 1)
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editData, setEditData] = useState(null)
	const [formData, setFormData] = useState({
		mobile: '',
		designation: '',
	})
	const [selectedPermissions, setSelectedPermissions] = useState({})
	const [permissionError, setPermissionError] = useState('')
	const [isDurationEnabled, setIsDurationEnabled] = useState(false)
	const [duration, setDuration] = useState({ from: '', to: '' })
	const [designationError, setDesignationError] = useState('')
	const [durationError, setDurationError] = useState('')

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const permissionList = useSelector(state => state.teamsReducer.permission)
	const isdeleted = useSelector(state => state.teamsReducer.isdeleted)
	const users = useSelector(state => state?.usersReducer.users)

	const designationIndex = designationOptions.findIndex(opt => opt.value === formData.designation)

	useEffect(() => {
		if (hubDetails?._id) {
			dispatch(appAllGetPermission('hub'))
			dispatch(
				appGetAllUser({
					page: 1,
					limit: 1000,
					hub: hubDetails?._id || hubId || permissionOfHub,
				}),
			)
		} else if (sansthaDetails?._id) {
			dispatch(appAllGetPermission('sanstha'))
			dispatch(
				appGetAllUser({
					page: 1,
					limit: 1000,
					sansthaId: sansthaDetails._id,
				}),
			)
		}
	}, [hubDetails?._id, sansthaDetails?._id])

	useEffect(() => {
		if (isdeleted) {
			const params = {
				page,
				limit: 10,
				...(hubDetails?._id && { hub: hubId || permissionOfHub }),
				...(sansthaDetails?._id && { sanstha: sansthaDetails._id }),
			}

			dispatch(appAllGetTeams(params))
		}
	}, [isdeleted])

	const handlePermissionChange = (permissionId, label) => {
		const newPermissions = {
			...selectedPermissions,
			[permissionId]: !selectedPermissions[permissionId],
		}
		setSelectedPermissions(newPermissions)
		if (Object.values(newPermissions).some(value => value)) {
			setPermissionError('')
		}
	}

	const handleEdit = item => {
		setEditMode(true)
		setEditData(item)

		const isHub = item?.userType === 'hub' || item?.hub
		const userId = isHub ? item?.userId?._id : item?._id

		setFormData({
			user: userId || '',
			mobile: item.mobile || (isHub ? item?.userId?.mobile : item?.mobile) || '',
			designation: item.designation || item?.joinedSanstha?.[0]?.designation || '',
		})

		const initialPermissions = {}
		const permissions = isHub ? item.permissions : item?.joinedSanstha?.[0]?.permissions || []
		permissions.forEach(perm => {
			initialPermissions[perm._id] = true
		})
		setSelectedPermissions(initialPermissions)

		if (item.from && item.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.from || '',
				to: item.to || '',
			})
		} else if (item?.joinedSanstha?.[0]?.from && item?.joinedSanstha?.[0]?.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.joinedSanstha[0].from || '',
				to: item.joinedSanstha[0].to || '',
			})
		} else {
			setIsDurationEnabled(false)
			setDuration({ from: '', to: '' })
		}

		setShowModal(true)
	}

	const handleSubmit = e => {
		e.preventDefault()

		const selectedPerms = Object.entries(selectedPermissions)
			.filter(([_, isSelected]) => isSelected)
			.map(([id]) => id)

		const payload = {
			mobile: formData.mobile,
			permissions: [],
			designation: '',
			sort: 0,
			inactive: false,

			...(hubDetails?._id && {
				userType: 'hub',
				hub: hubDetails._id || hubId || permissionOfHub,
				userId: formData.user,
			}),
			...(sansthaDetails?._id && {
				userType: 'sanstha',
				sanstha: sansthaDetails._id,
				sanstha: sansthaDetails?._id,
			}),
		}

		if (isDurationEnabled) {
			if (!formData.designation) {
				setDesignationError('Required ')
				return
			}
			setDesignationError('')

			payload.designation = formData.designation
			payload.sort = designationIndex
			payload.permissions = []
			payload.from = duration.from
			payload.to = duration.to
			payload.inactive = true

			if (!duration.from || !duration.to) {
				setDurationError('Required')
				return
			}
		} else {
			if (selectedPerms.length === 0) {
				setPermissionError('Please select at least one permission.')
				return
			}
			setPermissionError('')

			payload.permissions = selectedPerms
			payload.designation = formData.designation
			payload.sort = designationIndex
		}

		if (editMode) {
			dispatch(appUpdateTeams({ id: editData._id, ...payload })).then(() => {
				if (hubDetails) {
					dispatch(appAllGetTeams({ page, limit: 10, hub: hubId || permissionOfHub }))
				} else if (sansthaDetails) {
					dispatch(appAllGetTeams({ page, limit: 10, sanstha: sansthaDetails?._id }))
				}
			})
		} else {
			dispatch(appCreateTeams(payload))
				.then(() => {
					if (hubDetails) {
						dispatch(appAllGetTeams({ page, limit: 10, hub: hubId || permissionOfHub }))
					} else if (sansthaDetails) {
						dispatch(appAllGetTeams({ page, limit: 10, sanstha: sansthaDetails?._id }))
					}
				})
				.catch(err => {
					console.error('Create team error:', err)
				})
		}

		setShowModal(false)
		setEditMode(false)
		setEditData(null)
		setFormData({
			mobile: '',
			designation: '',
		})
		setSelectedPermissions({})
		setDuration({ from: '', to: '' })
		setPermissionError('')
		setDesignationError('')
	}

	const handleDeleteTeams = item => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this team?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				const payload = {
					_id: item?._id,
					mobile: item.mobile,
					designation: null,
					sort: null,
					userType: 'sanstha',
					inactive: false,
					sanstha: sansthaDetails?._id,
					userId: null,
					permissions: [],
					from: null,
					to: null,
				}
				// dispatch(appDeleteTeams(id)).then(() => {
				// 	if (hubDetails) {
				// 		dispatch(
				// 			appAllGetTeams({ page, limit: 10, hub: hubDetails._id || hubId || permissionOfHub }),
				// 		)
				// 	} else if (sansthaDetails) {
				// 		dispatch(appAllGetTeams({ page, limit: 10, sanstha: sansthaDetails?._id }))
				// 	}
				// })

				dispatch(appUpdateTeams(payload)).then(() => {
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							sanstha: sansthaDetails?._id,
						}),
					)
				})
			}
		})
	}

	return (
		<>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2"></h4>

				<div className="d-flex gap-2">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetTeams({
									...params,
									page: 1,
									limit: 100000,
									...(hubDetails?._id && {
										hub: hubDetails._id || hubId || permissionOfHub,
									}),
									...(sansthaDetails?._id && {
										sanstha: sansthaDetails._id,
									}),
									loading: false,
								}),
							)
						}
						columns={teamExportColumns}
						fileName="Management_Team"
						sheetName="Management"
						buttonText="Export Team"
					/>

					<button
						className="btn btn-primary"
						onClick={() => {
							setEditMode(false)
							setEditData(null)
							setFormData({ mobile: '', designation: '' })
							setSelectedPermissions({})
							setIsDurationEnabled(false)
							setDuration({ from: '', to: '' })
							setShowModal(true)
						}}
						style={{ marginLeft: '10px' }}
					>
						Add Team
					</button>
				</div>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead>
						<tr>
							<th> Sr. No.</th>
							<th data-column-id="sender">User</th>
							<th data-column-id="received" data-order="desc">
								Permission
							</th>
							<th data-column-id="received" data-order="desc">
								Previous Comittes
							</th>
							<th data-column-id="received" data-order="desc">
								Designation
							</th>
							<th data-column-id="received" data-order="desc">
								Duration
							</th>

							<th data-column-id="commands" data-formatter="commands" data-sortable="false">
								<div></div>
							</th>
						</tr>
					</thead>

					{teamsList?.length > 0 ? (
						<tbody>
							{teamsList?.map((item, index) => {
								const isHub = item?.userType === 'hub' || item?.hub
								const user = isHub ? item?.userId : item
								const sansthaInfo = !isHub ? item?.joinedSanstha?.[0] : null

								return (
									<tr key={item._id}>
										<td>{index + 1}</td>

										<td>
											<PostPreview value={user?.profilePic || '/img/user.jpg'} />
											{user?.firstName} {user?.lastName}
											<br />
											<small>{user?.mobile}</small>
										</td>

										<td style={{ maxWidth: '250px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
											{isHub
												? item?.permissions?.map((perm, i) => (
														<span key={perm._id}>
															{perm.label}
															{i < item.permissions.length - 1 ? ', ' : ''}
														</span>
												  ))
												: sansthaInfo?.permissions?.map((perm, i) => (
														<span key={i}>
															{perm.label}
															{i < sansthaInfo.permissions.length - 1 ? ', ' : ''}
														</span>
												  ))}
										</td>

										<td>
											{isHub
												? item?.inactive && (
														<span className="badge badge-success">Previous Committees</span>
												  )
												: sansthaInfo?.inactive && (
														<span className="badge badge-success">Previous Committees</span>
												  )}
										</td>

										<td>{isHub ? item?.designation : sansthaInfo?.designation}</td>

										<td>
											{isHub
												? `${item?.from || ''} - ${item?.to || ''}`
												: `${sansthaInfo?.from || ''} - ${sansthaInfo?.to || ''}`}
										</td>

										<td>
											<button
												type="button"
												className="btn btn-sm btn-info mr-2 command-edit"
												onClick={() => handleEdit(item)}
											>
												<em className="fa fa-edit fa-fw"></em>
											</button>
											<button
												type="button"
												className="btn btn-sm btn-danger command-delete"
												onClick={() => handleDeleteTeams(item)}
											>
												<em className="fa fa-trash fa-fw"></em>
											</button>
										</td>
									</tr>
								)
							})}
						</tbody>
					) : (
						<tbody>
							<tr>
								<td colSpan="7" className="text-center">
									No Management data available
								</td>
							</tr>
						</tbody>
					)}
				</table>
			</div>

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{editMode ? 'Edit Team' : 'Add New Team'}</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditData(null)
										setFormData({
											mobile: '',
										})
										setSelectedPermissions({})
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Select Users</label>
												<Select
													options={
														Array.isArray(users)
															? users.map(user => ({
																	value: user._id,
																	label: `${user.firstName} ${user.lastName || ''} (${user.mobile ||
																		''})`,
															  }))
															: []
													}
													onChange={option => {
														const selectedUser = Array.isArray(users)
															? users.find(u => u._id === option?.value)
															: null

														if (selectedUser) {
															setFormData(prev => ({
																...prev,
																user: selectedUser._id,
																mobile: selectedUser.mobile,
															}))
														}
													}}
													value={
														Array.isArray(users)
															? (() => {
																	const selectedUser = users.find(u => u._id === formData.user)
																	return selectedUser
																		? {
																				value: selectedUser._id,
																				label: `${selectedUser.firstName} ${selectedUser.lastName ||
																					''} (${selectedUser.mobile || ''})`,
																		  }
																		: null
															  })()
															: null
													}
													placeholder="Select User..."
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Designation </label>
												<Select
													options={designationOptions}
													value={designationOptions.find(opt => opt.value === formData.designation)}
													onChange={option => {
														setFormData(prev => ({
															...prev,
															designation: option.value,
														}))
														setDesignationError('')
													}}
													placeholder="Select Designation..."
													isSearchable
												/>
												{isDurationEnabled && designationError && (
													<div className="text-danger mt-2">{designationError}</div>
												)}
											</div>
										</div>
									</div>
									<div className="form-group">
										<label className="font-weight-bold mb-3">Permissions *</label>
										<div
											className="permissions-grid"
											style={{
												display: 'grid',
												gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
												gap: '10px',
												maxHeight: '200px',
												overflowY: 'auto',
												borderRadius: '4px',
											}}
										>
											{permissionList?.map(permission => (
												<div key={permission._id} className="custom-control custom-checkbox">
													<input
														type="checkbox"
														className="custom-control-input"
														id={`permission-${permission._id}`}
														checked={selectedPermissions[permission._id] || false}
														onChange={() =>
															handlePermissionChange(permission._id, permission.label)
														}
													/>
													<label
														className="custom-control-label"
														htmlFor={`permission-${permission._id}`}
														style={{
															cursor: 'pointer',
															padding: '2px 12px',
														}}
													>
														{permission.label}
													</label>
												</div>
											))}
										</div>
										{permissionError && <div className="text-danger mt-2">{permissionError}</div>}
									</div>
									<div className="form-group d-flex align-items-center">
										<label className="mr-3 mb-0" htmlFor="durationSwitch">
											Previous Comittes
										</label>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												id="durationSwitch"
												checked={isDurationEnabled}
												onChange={() => setIsDurationEnabled(prev => !prev)}
											/>
											<label className="custom-control-label" htmlFor="durationSwitch"></label>
										</div>
									</div>
									{isDurationEnabled && (
										<>
											{durationError && <div className="text-danger mt-2">{durationError}</div>}
											<div className="row">
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationFrom">From (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationFrom"
															min="1900"
															max="2099"
															step="1"
															value={duration.from}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	from: val,
																}))
																setDurationError('')
															}}
														/>
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationTo">To (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationTo"
															min="1900"
															max="2099"
															step="1"
															value={duration.to}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	to: val,
																}))
																setDurationError('')
															}}
														/>
													</div>
												</div>
											</div>
										</>
									)}
									<div className="modal-footer">
										<button className="btn btn-labeled btn-success" type="submit">
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Submit'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditData(null)
												setFormData({
													firstName: '',
													lastName: '',
													email: '',
													mobile: '',
												})
												setSelectedPermissions({})
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
export default Management
